import React from "react";
import { companyInfo } from "../mock";

const text = encodeURIComponent("Guten Tag Herr Janzen, ich habe eine Frage zur WEG-Verwaltung.");
export const WHATSAPP_URL = `https://wa.me/${companyInfo.phone.replace(/\D/g, "")}?text=${text}`;

export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-1.9c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.9S23.2 3 16 3zm0 23.6c-2.1 0-4.1-.6-5.9-1.6l-.4-.3-3.8 1.1 1.1-3.6-.3-.4c-1.2-1.8-1.8-3.9-1.8-6 0-6 4.9-10.8 11-10.8s11 4.8 11 10.8-4.9 10.8-10.9 10.8zm6-8.1c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.6.1-.2.1-.4 0-.6-.1-.2-.7-1.8-1-2.4-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

export const WhatsAppFloating = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Per WhatsApp schreiben"
    data-testid="whatsapp-floating-button"
    className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg shadow-black/20 hover:bg-[#1ebe5b] hover:-translate-y-0.5 transition-all"
  >
    <WhatsAppIcon className="w-6 h-6" />
    <span className="font-semibold text-[14px] hidden sm:inline">WhatsApp</span>
  </a>
);
